"use strict";

module.exports = require('buffer/').Buffer;